import Vue from 'vue'
import Router from 'vue-router'
import Upload from './views/Upload.vue'
import Download from './views/Download.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'upload',
      component: Upload
    },
    {
      path: '/download/:hash',
      name: 'download',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Download
    }
  ]
})
